import { FeatureFlag } from 'src/constants/feature-flag';
import { useFlagsAndLoadingState } from 'src/contexts/launch-darkly-flags-ready-context';

export function useOnboardingRedesign(): { isRedesign: boolean; flagsReady: boolean } {
  const { flagsReady, flags } = useFlagsAndLoadingState();

  return {
    isRedesign: flagsReady && Boolean(flags[FeatureFlag.ClientPortalRedesignOnboarding]),
    flagsReady,
  };
}
